import { useContext } from 'react';
import { TwigGlobalContext } from '@builder/context/TwigFeatureProvider/TwigGlobalProvider';

export const useHasFixedPriceQuotesFeature = () =>
  useContext(TwigGlobalContext)?.getBooleanValue('hasFixedPriceQuotesFeature', false) ?? false;
